module.exports = __webpack_public_path__ + "img/update-photo.90657124.svg";